import {CSSProperties, FC} from 'react';


export interface IIconCarryingProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCarrying: FC<IIconCarryingProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M17.5 7.889h-3.216c.214-.379.337-.815.337-1.28C14.62 5.17 13.45 4 12.01 4a2.612 2.612 0 0 0-2.609 2.61c0 .464.123.9.337 1.279H6.5L3 20.982v-.019h18L17.5 7.89Zm-5.489-2.573c.713 0 1.293.58 1.293 1.293 0 .65-.482 1.19-1.107 1.28h-.371a1.295 1.295 0 0 1-1.108-1.28c0-.713.58-1.293 1.293-1.293ZM4.825 19.647 7.328 9.205h4.417a2.633 2.633 0 0 0 .533 0h4.315l2.547 10.442H4.825Z" />
            <path d="m11.956 16.639-1.637-2.493 1.344-1.682a.29.29 0 0 0 .06-.187c0-.248-.315-.503-.563-.503a.31.31 0 0 0-.27.143l-1.622 2.207v-2.05c0-.21-.248-.3-.488-.3-.248 0-.488.09-.488.3v4.88c0 .203.24.308.488.308.24 0 .488-.105.488-.308v-1.472l.405-.51 1.412 2.14c.082.135.21.187.338.187.285 0 .585-.247.585-.488 0-.06-.015-.12-.052-.172ZM15.484 14.38h-1.276c-.195 0-.3.194-.3.382 0 .195.105.383.3.383h.608v.443c0 .585-.3.863-.788.863-.496 0-.78-.278-.78-.863v-2.095c-.001-.585.284-.863.787-.863.638 0 .759.39.781.743.008.233.225.308.488.308.323 0 .488-.09.488-.466 0-.9-.758-1.441-1.794-1.441-.954 0-1.727.465-1.727 1.72v2.094c0 1.253.766 1.719 1.757 1.719.99 0 1.764-.465 1.764-1.72v-.893c0-.165-.112-.315-.308-.315Z" />
        </svg>
    );
};
